<div class="flex-control flex-column flex-height">
  <div class="flex-header text-center">
    <button class="btn btn-secondary btn-min mr-sm" (click)="generatePdf('print')">Print</button>
    <button class="btn btn-tertiary btn-outline btn-min mr-sm" (click)="generatePdf('save')">Download</button>
    <button class="btn btn-primary btn-outline btn-min"
            (click)="openSendModal()"
            *ngIf="print_type == 'Report'"
            [disabled]="isGeneratingPdf">
      <i class="fa fa-spinner fa-spin mr-sm" *ngIf="isGeneratingPdf"></i>
      <i class="fa fa-paper-plane mr-sm" *ngIf="!isGeneratingPdf"></i>
      {{isGeneratingPdf ? 'Preparing PDF…' : 'Send as Secure Message'}}
    </button>
  </div>
  <div class="flex-body scroll-browser">
    <div #receipt *ngIf="print_type == 'Report'" class="main-wrapper print-wrapper" style="max-width:10.5in; margin:auto;">
      <div class="print-header mb">
        <div class="row">
          <h3 class="m0 col-xs-6 pb fw-500">Super Bill</h3>
          <h4 class="m0 col-xs-6 text-right pb fw-500">Billing Month: {{report_date | date: 'MMMM, y'}}</h4>
        </div>
      </div>
      <div class="print-body">
        <div class="row">
          <div class="col-xs-6">
            <h4 class="text-bold mb-lg">Patient Information</h4>
            <div class="row mb">
              <h5 class="col-xs-4 m0">Name:</h5>
              <h5 class="col-xs-8 fw-500 text-capitalize m0">{{bill.name}}</h5>
            </div>
            <div class="row mb">
              <h5 class="col-xs-4 m0">Address:</h5>
              <h5 class="col-xs-8 fw-500 m0">{{bill.patient_address}}</h5>
            </div>
            <div class="row mb">
              <h5 class="col-xs-4 m0">Phone:</h5>
              <h5 class="col-xs-8 fw-500 m0">{{bill.phone_number | mask: '(000) 000-0000'}}</h5>
            </div>
            <div class="row mb">
              <h5 class="col-xs-4 m0">Date of Birth:</h5>
              <h5 class="col-xs-8 fw-500 m0">{{bill.dob}}</h5>
            </div>
            <div class="row mb">
              <h5 class="col-xs-4 m0">Consultant:</h5>
              <h5 class="col-xs-8 fw-500 m0">{{bill.billing_provider_name}}</h5>
            </div>
            <ng-container *ngIf="programme_category === 'private_programme'">
              <div class="row mb">
                <h5 class="col-xs-4 m0">Package Name:</h5>
                <h5 class="col-xs-8 fw-500 m0">{{bill?.programme_json?.private_package_name}}</h5>
              </div>
              <div class="row mb">
                <h5 class="col-xs-4 m0">Fee:</h5>
                <h5 class="col-xs-8 fw-500 m0">{{bill?.programme_json?.private_pay_amount}}</h5>
              </div>
              <div class="row mb">
                <h5 class="col-xs-4 m0">Minutes Spent:</h5>
                <h5 class="col-xs-8 fw-500 m0">{{bill.time_spent}}</h5>
              </div>
            </ng-container>
          </div>
          <div class="col-xs-6">
            <h4 class="text-bold mb-lg">Provider Information</h4>
            <div class="row mb">
              <h5 class="col-xs-4 m0">Practice Name:</h5>
              <h5 class="col-xs-8 fw-500 text-capitalize m0">{{bill.practice_name}}</h5>
            </div>
            <div class="row mb">
              <h5 class="col-xs-4 m0">Practice Address:</h5>
              <h5 class="col-xs-8 fw-500 m0">{{bill.practice_address}}</h5>
            </div>
            <div class="row mb">
              <h5 class="col-xs-4 m0">Provider:</h5>
              <h5 class="col-xs-8 fw-500 m0">{{bill.billing_provider_name}}</h5>
            </div>
            <div class="row mb">
              <h5 class="col-xs-4 m0">NPI:</h5>
              <h5 class="col-xs-8 fw-500 m0">{{bill.billing_provider_npi}}</h5>
            </div>
            <div class="row mb">
              <h5 class="col-xs-4 m0">Phone:</h5>
              <h5 class="col-xs-8 fw-500 m0">{{bill.practice_phone | mask: '(000) 000-0000'}}</h5>
            </div>
            <div class="row mb">
              <h5 class="col-xs-4 m0">Email:</h5>
              <h5 class="col-xs-8 fw-500 m0">{{bill.practice_email}}</h5>
            </div>
            <div class="row mb">
              <h5 class="col-xs-4 m0">Referring provider:</h5>
              <h5 class="col-xs-8 fw-500 m0">{{bill.care_manager_name}}</h5>
            </div>
            <div class="row">
              <h5 class="col-xs-4 m0">Referring provider NPI:</h5>
              <h5 class="col-xs-8 fw-500 m0">{{bill.care_manager_npi}}</h5>
            </div>
          </div>
        </div>
      </div>

      <ng-container *ngIf="bill && bill.diagnosis?.length">
        <h4 class="text-bold">Diagnosis</h4>
        <div class="table-responsive">
          <table class="table table-bordered table-striped table-hover">
            <thead>
            <tr>
              <th class="text-center col-xs-2">ICD-10</th>
              <th>ICD-10 Description</th>
            </tr>
            </thead>
            <tbody>
            <tr *ngFor="let diagnos of bill.diagnosis">
              <td class="text-center col-xs-2">{{diagnos[0]}}</td>
              <td>{{diagnos[1]}}</td>
            </tr>
            </tbody>
          </table>
        </div>
      </ng-container>


      <ng-container *ngIf="programme_category !== 'private_programme'">
        <h4 class="text-bold">Applicable CTPs - Total Time Spent {{bill.time_spent}} Mins</h4>
        <div class="table-responsive">
          <table class="table table-bordered table-striped table-hover">
            <thead>
            <tr>
              <th class="text-center col-xs-2">CPT Code</th>
              <th>CRT Description</th>
              <th class="text-center">Mins</th>
              <th class="text-right">Amount</th>
            </tr>
            </thead>
            <tbody>
            <tr *ngFor="let cpt of bill.cpt_codes">
              <td class="text-center col-xs-2">{{cpt[0]}}</td>
              <td>{{cpt[1]}}</td>
              <td class="text-center">{{cpt[2]}}</td>
              <td class="text-right">${{cpt[3]}}</td>
            </tr>
            </tbody>
          </table>
        </div>
      </ng-container>
      <app-print-report-section [reportDetails]="reportDetails"></app-print-report-section>
      <div class="fs12 text-center">Printed on {{today | date: 'medium'}} by <b>wellwink.com</b></div>
    </div>
  </div>
</div>

<!-- Send as Secure Message modal -->
<div class="modal flex-modal fade in" bsModal #sendModal="bs-modal" [config]="{backdrop: 'static'}" tabindex="-1" (onHide)="onSendModalHide()">
  <div class="modal-dialog modal-md">
    <div class="modal-content">

      <div class="modal-header">
        <button class="close" type="button" (click)="sendModal.hide()">
          <i class="fa fa-times fs16"></i>
        </button>
        <h4 class="modal-title"><i class="fa fa-paper-plane mr-sm text-primary"></i>Send Superbill as Secure Message</h4>
      </div>

      <div class="modal-body">

        <!-- PDF attachment chip -->
        <div class="alert alert-info p-sm mb" *ngIf="pdfFile">
          <i class="fa fa-file-pdf-o mr-sm text-danger"></i>
          <strong>{{pdfFile.name}}</strong>
          <span class="text-muted ml-sm fs12">({{(pdfFile.size / 1024).toFixed(1)}} KB) — auto-attached</span>
        </div>

        <!-- Recipient field with typeahead -->
        <div class="form-group" style="position:relative;">
          <label class="fw-500">To (Direct Address) <span class="text-danger">*</span></label>
          <input type="text" class="form-control"
                 placeholder="Search contacts or enter direct address…"
                 [(ngModel)]="sendToAddress"
                 (ngModelChange)="onToInput($event)"
                 (blur)="closeDropdownDelayed()"
                 autocomplete="off" />
          <i class="fa fa-spinner fa-spin" style="position:absolute;right:12px;top:36px;" *ngIf="toSearchLoading"></i>

          <!-- Typeahead dropdown -->
          <div *ngIf="showToDropdown" style="position:absolute;top:100%;left:0;right:0;background:#fff;border:1px solid #c8d3db;border-radius:4px;z-index:1100;max-height:220px;overflow-y:auto;box-shadow:0 4px 12px rgba(0,0,0,0.12);">
            <div *ngIf="localContacts.length > 0">
              <div style="padding:6px 12px;font-size:11px;font-weight:600;color:#6c757d;border-bottom:1px solid #eee;background:#f8f9fa;">Your Contacts</div>
              <div *ngFor="let r of localContacts"
                   (mousedown)="selectContact(r)"
                   style="padding:10px 12px;cursor:pointer;border-bottom:1px solid #f4f5f7;"
                   class="contact-option">
                <div class="fw-500 fs13">{{r.name}}</div>
                <div class="text-muted fs12">{{r.direct_address}}</div>
              </div>
            </div>
            <div *ngIf="directoryContacts.length > 0">
              <div style="padding:6px 12px;font-size:11px;font-weight:600;color:#6c757d;border-bottom:1px solid #eee;background:#f8f9fa;">
                <i class="fa fa-search mr-sm"></i>Directory
              </div>
              <div *ngFor="let r of directoryContacts"
                   (mousedown)="selectContact(r)"
                   style="padding:10px 12px;cursor:pointer;border-bottom:1px solid #f4f5f7;"
                   class="contact-option">
                <div class="fw-500 fs13">{{r.name}}</div>
                <div class="text-muted fs12">{{r.direct_address}}</div>
                <div class="text-muted fs12" *ngIf="r.organization">{{r.organization}}<span *ngIf="r.specialty"> · {{r.specialty}}</span></div>
              </div>
            </div>
          </div>
        </div>

        <!-- Subject -->
        <div class="form-group">
          <label class="fw-500">Subject</label>
          <input type="text" class="form-control" [(ngModel)]="sendSubject" placeholder="Subject" />
        </div>

        <!-- Body -->
        <div class="form-group">
          <label class="fw-500">Message (optional)</label>
          <textarea class="form-control" style="min-height:150px;" rows="3" [(ngModel)]="sendBody"
                    placeholder="Add a note to accompany the superbill…"></textarea>
        </div>

      </div>

      <div class="modal-footer">
        <button type="button" class="btn btn-secondary mr-sm"
                (click)="sendMessage()"
                [disabled]="!sendToAddress.trim() || !pdfFile || isSending">
          <i class="fa fa-spinner fa-spin mr-sm" *ngIf="isSending"></i>
          <i class="fa fa-paper-plane mr-sm" *ngIf="!isSending"></i>
          {{isSending ? 'Sending…' : 'Send'}}
        </button>
        <button type="button" class="btn btn-tertiary btn-outline" (click)="sendModal.hide()" [disabled]="isSending">Cancel</button>
      </div>

    </div>
  </div>
</div>
